import Head from 'next/head';
import { Provider } from 'react-redux';

import config from 'config';
import { initAlfaMetrics } from 'newclick-alfa-metrics';
import { analyticsConfig } from 'src/new-analytics';

import { withReduxStore } from '@store/index';
import { parseAndSaveQuery, saveConfiguration } from '@store/settings/actions';

import './styles/_global.scss';

const App = ({ Component, pageProps, store }) => {
    if (typeof window !== 'undefined') {
        initAlfaMetrics({
            appId: config.get('client.appId'),
            config: analyticsConfig
        });
    }

    return (
        <Provider store={store}>
            <>
                <Head>
                    <title>Запрос денег</title>
                    <meta
                        name='viewport'
                        content='width=device-width, minimum-scale=1, maximum-scale=5, initial-scale=1'
                    />
                </Head>
                <Component {...pageProps} />
            </>
        </Provider>
    );
};

App.getInitialProps = ({ ctx: { query, res, store } }) => {
    /** На сервере при первом запросе клиента, сохраняем в redux конфиг с сервера и query параметры */
    if (typeof window === 'undefined') {
        store.dispatch(saveConfiguration(res?.configuration));
        store.dispatch(parseAndSaveQuery(query));
    }
};

export default withReduxStore(App);
